<div
  class="uploader-container"
  [class.has-preview]="previewUrl"
  [class.is-loading]="busy"
  (click)="!previewUrl && !busy && fileInput.click()"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragOver($event)"
  (drop)="onDropSuccess($event)">
  <ng-container *ngIf="previewUrl; else dropzone">
    <div class="preview-wrapper" [class.preview-wrapper--loading]="busy">
      @if (filePreview; as preview) {
        <div class="preview preview--file" aria-hidden="true">
          <mat-icon>{{ preview.icon }}</mat-icon>
          <span>{{ preview.label }}</span>
        </div>
      } @else {
        <img [src]="previewUrl" class="preview" [style]="previewImageStyles" alt=""/>
      }
      <div class="preview-loader-overlay" *ngIf="busy">
        <div class="preview-loader"></div>
      </div>
    </div>
    <button
      type="button"
      class="remove-btn"
      *ngIf="!busy && canRemove"
      (click)="removeImage($event)"
      [attr.aria-label]="'removeImage' | translate"
      [title]="'removeImage' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </ng-container>

  <ng-template #dropzone>
    <div class="dropzone-content" *ngIf="!busy; else dropzoneLoader">
      <mat-icon class="upload-icon">cloud_upload</mat-icon>
      <div class="description">{{ description }}</div>
      <div class="additional-description" *ngIf="additionalDescription">{{ additionalDescription }}</div>
    </div>
    <ng-template #dropzoneLoader>
      <div class="dropzone-content dropzone-content--loading">
        <div class="preview-loader"></div>
      </div>
    </ng-template>
  </ng-template>

  <input
    hidden
    type="file"
    #fileInput
    [attr.accept]="allowedFileExtensions.join(',')"
    (change)="uploadFile($event.target.files)"
  />
</div>
